import { link } from 'fs';
import dynamic from 'next/dynamic';

import PATHS from './paths';

interface IFooterLink {
	url: string;
	title: string;
	openNewTab?: boolean;
}

interface IFooterMenuLink {
	sectionTitle: string;
	links: IFooterLink[];
}

const PRODUCTS_SECTION_LINKS: IFooterLink[] = [
	{
		url: 'https://supra.com/vertical-integration/',
		title: 'Supra Layer1',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/containers/',
		title: 'Containers',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/oracles-product/',
		title: 'Oracles',
		openNewTab: true,
	},
	{
		url: '/dvrf',
		title: 'dVRF',
	},
	{
		url: '/',
		title: 'Live Data Feeds',
	},
	{
		url: 'https://supra.com/documents/Supra-IntraLayer-Whitepaper.pdf',
		title: 'IntraLayer',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/PoEL/',
		title: 'Proof of Efficient Liquidity',
		openNewTab: true,
	},
	// {
	// 	url: '/validators',
	// 	title: 'Validators',
	// },
	{
		url: 'https://supra.com/DFMM/',
		title: 'Dynamic Function Market Maker',
		openNewTab: true,
	},
	{
		url: 'https://suprascan.io/',
		title: 'SupraScan Block Explorer',
		openNewTab: true,
	},
];

const DEVELOPERS_SECTION_LINKS: IFooterLink[] = [
	{
		title: 'Dev Center',
		url: 'https://supra.com/developers/',
		openNewTab: true,
	},
	{
		url: 'https://docs.supra.com/',
		title: 'Dev Docs',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/bug-bounty',
		title: 'Bug Bounty',
		openNewTab: true,
	},
];

const COMMUNITY_SECTION_LINKS: IFooterLink[] = [
	{
		title: 'Blast Off',
		url: 'https://supra.com/blastoff/',
		openNewTab: true,
	},
	{
		url: 'https://hub.supra.com/supraspartans',
		title: 'Supra Spartans',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/events/',
		title: 'Events',
		openNewTab: true,
	},
];

const ABOUT_SECTION_LINKS: IFooterLink[] = [
	{
		title: 'Team',
		url: 'https://supra.com/about/',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/research-team/',
		title: 'Research Team',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/contact/',
		title: 'Contact',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/careers/',
		title: 'Careers',
		openNewTab: true,
	},
];

const ECOSYSTEM_SECTION_LINKS: IFooterLink[] = [
	{
		url: 'https://supra.com/ecosystem/',
		title: 'Supra L1 Ecosystem',
		openNewTab: true,
	},
	{
		title: 'Partnership',
		url: 'https://supra.com/partnerships/',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/showdown/',
		title: 'Super dAPP Showdown',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/defi-revolution/',
		title: 'The DeFi Revolution',
		openNewTab: true,
	},
	{
		url: 'https://hub.supra.com/ape',
		title: 'ApeChain Powered by Supra',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/affiliates/',
		title: 'Supra Affiliates',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/evm/',
		title: 'SupraEVM',
		openNewTab: true,
	},
];

const LEARN_SECTION_LINKS: IFooterLink[] = [
	{
		title: 'Research',
		url: 'https://supra.com/research/',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/devwire/',
		title: 'DevWire',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/academy/supra-token-tokenomics-and-utility/',
		title: '$SUPRA Tokenomics and Utility',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/use-cases/',
		title: 'Use Cases',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/academy/',
		title: 'Academy',
		openNewTab: true,
	},
	{
		url: 'https://hub.supra.com/tech-behind-supra?utm_source=website&utm_medium=webinar-popup',
		title: 'Tech Behind Supra Webinar',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/training/',
		title: 'Training Center',
		openNewTab: true,
	},
	{
		url: 'https://supra.com/news/',
		title: 'News',
		openNewTab: true,
	},
	// {
	// 	url: 'https://supra.com/faq/',
	// 	title: 'FAQ',
	// 	openNewTab: true,
	// },
];

// const CONNECT_SECTION_LINKS: IFooterLink[] = [
// 	{
// 		url: 'https://supra.com/contact/',
// 		title: 'Contact',
// 	},
// 	{
// 		url: 'https://supra.com/careers/',
// 		title: 'Careers',
// 	},
// ];

// const EXPLORE_SECTION_LINKS: IFooterLink[] = [
// 	{
// 		url: 'https://supra.com/vision/',
// 		title: 'Vision',
// 		openNewTab: true,
// 	},
// 	{
// 		url: 'https://supra.com/about/',
// 		title: 'About Us',
// 		openNewTab: true,
// 	},
// 	{
// 		url: 'https://supra.com/partnerships/',
// 		title: 'Partnerships',
// 		openNewTab: true,
// 	},
// ];

const LINKS = {
	HEADER: {
		DEFAULT: [
			/**
			 * displayName: string to be shown to user in navigation
			 * link: href for link (next)
			 * subMenu: array to show the other related links of this particular item
			 * dynamic: subMenu comes from API and contains more than a single column
			 */
			{
				displayName: 'DATA',
				link: PATHS.CATALOG.ROOT,
				dynamic: false,
				// subMenu: [
				// 	{ displayName: 'crypto', link: PATHS.CATALOG.ROOT },
				// 	{ displayName: 'forex', link: `${PATHS.CATALOG.ROOT}?crypto_category=forex` },
				// 	{ displayName: 'commodities', link: `${PATHS.CATALOG.ROOT}?crypto_category=commodities` },
				// 	{ displayName: 'equities', link: `${PATHS.CATALOG.ROOT}?crypto_category=equities` },
				// ],
			},
			{
				displayName: 'NETWORKS',
				link: PATHS.NETWORKS.ROOT('mainnet', 'pull'),
				// subMenu: [
				// 	{
				// 		displayName: 'Dora 1.0',
				// 		link: PATHS.NETWORKS.ROOT('mainnet', 'pull', '1'),
				// 	},
				// 	{
				// 		displayName: 'Dora 2.0',
				// 		link: PATHS.NETWORKS.ROOT('mainnet', 'pull', '2'),
				// 	},
				// ],
				dynamic: false,
			},
			{
				displayName: 'PROVIDERS',
				link: PATHS.PROVIDER.ROOT,
				subMenu: [],
				dynamic: false,
			},
			{
				displayName: 'dVRF',
				link: PATHS.VRF.ROOT,
				subMenu: [],
				dynamic: false,
			},
			{
				displayName: 'INDICES',
				link: PATHS.INDICES.ROOT,
				subMenu: [],
				dynamic: false,
			},
			{
				displayName: 'VALIDATORS',
				link: PATHS.VALIDATORS.ROOT,
				subMenu: [],
				dynamic: false,
			},
			// {
			// 	displayName: 'VALIDATORS',
			// 	link: PATHS.VALIDATORS.ROOT,
			// 	subMenu: [],
			// 	dynamic: false,
			// },
			// {
			//   displayName: 'Provider',
			//   link: PATHS.HOME,
			//   subMenu: [],
			//   dynamic: false,
			// },
			{
				displayName: 'DOCS',
				link: 'https://docs.supra.com/oracles/data-feeds',
				subMenu: [],
				dynamic: false,
			},
			// {
			//   displayName: 'VRF',
			//   link: '/vrf',
			//   dynamic: false,
			//   subMenu: [],
			// },
			// {
			//   displayName: 'Learn',
			//   link: null,
			//   dynamic: false,
			//   subMenu: [
			//     {
			//       id: '',
			//       displayName: 'News',
			//       link: 'https://supra.com/news/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//     {
			//       id: '',
			//       displayName: 'Academy',
			//       link: 'https://supra.com/academy/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//     {
			//       id: '',
			//       displayName: 'FAQ',
			//       link: 'https://supra.com/faq/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//   ],
			// },
			// {
			//   displayName: 'Explore',
			//   link: null,
			//   dynamic: false,
			//   subMenu: [
			//     {
			//       id: '',
			//       displayName: 'Vision',
			//       link: 'https://supra.com/vision/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//     {
			//       id: '',
			//       displayName: 'About Us',
			//       link: 'https://supra.com/about/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//     {
			//       id: '',
			//       displayName: 'Partnerships',
			//       link: 'https://supra.com/partnerships/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//   ],
			// },
			// {
			//   displayName: 'Connect',
			//   link: null,
			//   dynamic: false,
			//   subMenu: [
			//     {
			//       id: '',
			//       displayName: 'Contact',
			//       link: 'https://supra.com/contact/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//     {
			//       id: '',
			//       displayName: 'Careers',
			//       link: 'https://supra.com/careers/',
			//       openNewTab: true,
			//       name: '',
			//       description: '',
			//       iconUrl: '',
			//       slug: '',
			//     },
			//   ],
			// },
		],
		TOGGLE_MENU: [
			{
				displayName: 'Documentation',
				link: 'https://docs.supra.com/oracles/data-feeds',
			},
			{
				displayName: 'Status',
				link: 'https://supraoracles.statuspage.io/',
			},
		],
	},
	FOOTER: {
		DEFAULT: [
			{
				sectionTitle: 'PRODUCTS',
				links: PRODUCTS_SECTION_LINKS,
				sectionClass: 'w-36',
			},
			{
				sectionTitle: 'DEVELOPERS',
				links: DEVELOPERS_SECTION_LINKS,
				sectionClass: 'w-24',
			},
			{
				sectionTitle: 'ECOSYSTEM',
				links: ECOSYSTEM_SECTION_LINKS,
				sectionClass: 'w-44',
			},
			{
				sectionTitle: 'LEARN',
				links: LEARN_SECTION_LINKS,
				sectionClass: 'w-40',
			},
			// {
			// 	sectionTitle: 'EXPLORE',
			// 	links: EXPLORE_SECTION_LINKS,
			// 	sectionClass: 'w-32',
			// },
			{
				sectionTitle: 'COMMUNITY',
				links: COMMUNITY_SECTION_LINKS,
				sectionClass: 'w-32',
			},
			{
				sectionTitle: 'ABOUT',
				links: ABOUT_SECTION_LINKS,
				sectionClass: 'w-32',
			},

			// {
			// 	sectionTitle: 'CONNECT',
			// 	links: CONNECT_SECTION_LINKS,
			// },
		],
		COPYRIGHT: [
			{
				title: 'Privacy',
				url: 'https://supra.com/privacy-policy/',
			},
			{
				title: 'Terms of Use',
				url: 'https://supra.com/terms-of-use/',
			},
			{
				title: 'Website Data Usage & Cookies',
				url: 'https://supra.com/cookie-policy/',
			},
			{
				title: 'Bug Disclosure',
				url: 'https://supra.com/bug-disclosure-policy/',
			},
		],
	},
};

export default LINKS;
